<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <template v-if="searchShow">
            <div class="item-son">
              <el-input
                  v-model="listParams.searchKey"
                  placeholder="搜索关键词"
                  clearable
                  @keyup.enter.native="SearchAdvertisementList"
              ></el-input>
            </div>
            <div class="item-son">
              <el-select
                  filterable
                  v-model="listParams.adSiteId"
                  clearable
                  placeholder="请选择广告位置"
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in adLocationData"
                    :key="index"
                    :label="item.name"
                    :value="item.adSiteId"
                ></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-select
                  v-model="listParams.status"
                  clearable
                  placeholder="请选择状态"
                  style="width: 120px"
              >
                <el-option label="正常" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-button type="primary" @click="SearchAdvertisementList"
              >查询 <i class="el-icon-search"></i>
              </el-button>
            </div>
          </template>


          <div class="item-son" v-if="addShow">
            <el-button type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%"
          row-key="menuId"
          v-loading="loading"
          element-loading-text="等待接口数据返回中······"
      >
        <el-table-column
            align="center"
            fixed
            label="序号"
            type="index"
            width="100"
        >
          <template slot-scope="scope">
                <span>{{
                    (pages.pageNo - 1) * pages.pageSize + scope.$index + 1
                  }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="adSiteName" label="位置" width="120" align="center">
        </el-table-column>

        <el-table-column prop="name" label="名称" width="200" align="center">
        </el-table-column>
        <el-table-column
            prop="startTime"
            label="有效期"
            width="330"
            align="center"
        >
          <template slot-scope="scope">
            {{ `${scope.row.startTime} 至 ${scope.row.expireTime}` }}
          </template>
        </el-table-column>

        <el-table-column
            prop="eventType"
            label="事件"
            width="120"
            align="center"
        >
        </el-table-column>

        <el-table-column prop="utime" label="时间" width="160" align="center">
        </el-table-column>
        <el-table-column prop="code" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
                :disabled="statusShow"
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="changeSwitch(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="180" fixed="right">
          <template slot-scope="scope">
            <el-button
                size="mini"
                v-if="editShow"
                @click="handleClick('edit', scope.row)"
                type="warning"
                plain
            >编辑
            </el-button
            >
            <el-button
                v-if="deleteShow"
                size="mini"
                @click="handleDelete(scope.row)"
                type="primary"
                plain
            >删除
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.pageNo"
            :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="增加/编辑广告库"
        :visible.sync="dialogVisible"
        width="500px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="85px"
        >

          <el-form-item label="位置" prop="adSite">
            <el-select
                filterable
                v-model="params.adSite"
                clearable
                placeholder="请选择广告位置"
                style="width: 100%"
            >
              <el-option
                  v-for="(item) in adLocationData"
                  :key="item.adSite"
                  :label="item.name"
                  :value="item.adSite"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="广告图">

            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  >
                  <!-- <div slot="error" class="up-btn" @click="getPolicy" v-loading="loading1"  style="width: 74px; height: 74px; line-height: 67px">
              <p style="font-size:12px;">加载失败</p>
                  </div> -->
                  </el-image>
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPolicy"
                    v-if="isMoer"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="file"
                  @change="getFile"
                  accept="image/png,image/jpg"
              />
            </div>

            <div class="small-gary">建议上传尺寸 320 * 150 px</div>
          </el-form-item>

          <el-form-item label="名称" prop="name">
            <el-input
                placeholder="请填写广告名称"
                v-model="params.name"
            ></el-input>
          </el-form-item>

          <el-form-item label="有效期">
            <el-date-picker
                style="width: 100%"
                v-model="birthdayDate"
                @change="handleDateChange(arguments)"
                type="datetimerange"
                range-separator="至"
                start-placeholder="起始时间"
                end-placeholder="截止时间"
            >
              <!-- value-format="yyyy-MM-dd HH:mm:ss" -->
            </el-date-picker>
          </el-form-item>

          <el-form-item label="事件">
            {{ params.status }}9999
            <el-tabs v-model="params.eventType" @tab-click="lsithand">
              <el-tab-pane label="无事件" name="NON"></el-tab-pane>
              <el-tab-pane label="跳链接" name="URL">
                <el-input
                    placeholder="跳转链接"
                    v-model="params.eventUrl"
                ></el-input>
              </el-tab-pane>
              <el-tab-pane label="跳视图" name="VIEW" disabled>
                <el-input
                    placeholder="跳转视图标识"
                    v-model="params.event_view"
                ></el-input>
              </el-tab-pane>
              <el-tab-pane label="跳详情" name="DETAIL" disabled>
                <el-input
                    placeholder="跳转详情视图"
                    v-model="params.event_view"
                    style="margin-bottom: 15px"
                ></el-input>
                <el-input
                    placeholder="跳转详情ID"
                    v-model="params.detail_id"
                ></el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {ossUpload} from "@utils/filters/upload";

import {PAGE_SIZE, FILE_ROOT, JOB_STATUS} from "@config";
import {isEmpty} from '../../utils/tools';

export default {
  data() {
    return {
      listParams: {},
      params: {},
      loading: false,
      adLocationData: [],
      tableData: [],
      total: 0,
      dialogVisible: false,
      PAGE_SIZE,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      birthdayDate: "",
      activeName: '0',
      rules: {
        adSite: [
          {
            required: true,
            message: "请选择广告位置",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请填写广告名称",
            trigger: "change",
          },
        ],
      },

      /* 广告图
        */
      srcList: [],
      isMoer: true,

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,

    };
  },
  created() {
    this.adLocation();
    this.queryTableData();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcList = []
        this.isMoer = true
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'ad:store:query') {
            this.searchShow = true
          }
          if (item.code == 'ad:store:add') {
            this.addShow = true
          }
          if (item.code == "ad:store:delete") {
            this.deleteShow = true
          }
          if (item.code == "ad:store:edit") {
            this.editShow = true
          }
          if (item.code == "ad:store:status") {
            this.statusShow = false
          }
        })
      }
    },
    /* 上传广告图片 */
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList,
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.img = this.srcList[0];
    },
    lsithand(tab, event) {
      this.params.eventType == tab.name
    },

    SearchAdvertisementList() {
      this.pages.pageNo = 1
      this.queryTableData()
    },

    /**
     * 主列表
     */
    async queryTableData() {
      this.loading = true;

      const {data: resData} = await this.$get("ad/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.total = resData.page.count;
    },

    /**
     * 广告位置列表
     */
    async adLocation() {
      this.loading = true;

      const {data: resData} = await this.$get("ad/site/list", {
        params: {
          paging: false,
          status: 1,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      resData.data.sort(function (a, b) {
        return b.seq - a.seq;
      });
      this.adLocationData = resData.data;
    },

    /**
     * 修改广告库状态
     */
    async changeSwitch(b) {
      const {data: resData} = await this.$put(`ad/info/status/${b.adInfoId}`);
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "edit") {
        //编辑
        this.isDisabled = true;
        const {data: resData} = await this.$get(`ad/info/${row.adInfoId}`, {
          headers: {
            isLoading: true,
          },
        });

        this.srcList = []
        this.isMoer = true

        if (resData.result != 200) return;
        if (isEmpty(resData.data)) return;
        this.birthdayDate = [
          [resData.data.startTime],
          [resData.data.expireTime],
        ];
        this.params = resData.data;
        if (!isEmpty(resData.data.img)) {
          this.srcList.push(resData.data.img)
          this.isMoer = false
        }
      }
      if (type == "add") {
        this.params = {};
        this.birthdayDate = "";
      }
    },

    /**
     * 编辑/新增
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add") {

            const {data: resData} = await this.$post("ad/info", this.params, {
              headers: {
                isLoading: true,
              },
            });

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const {data: resData} = await this.$put(
                "ad/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }
        });
      });
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `ad/info/${row.adInfoId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.queryTableData();

        this.$message.success("删除成功!");
      });
    },

    /**
     *  日期选择
     */
    handleDateChange(args) {
      if (args[0]) {
        this.params.startTime = args[0][0];
        this.params.expireTime = args[0][1];
      } else {
        this.params.startTime = "";
        this.params.expireTime = "";
      }
    },
    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;

      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;

      this.queryTableData();
    },
  },
};
</script>
<style lang="scss" scoped>
.small-gary {
  font-size: 12px;
  color: #aaaaaa;
  margin-top: 10px;
}
</style>
